import { Routes } from '@angular/router';
import {NgxPermissionsGuard } from 'ngx-permissions';
import { QuestionsComponent } from '../online-mcq/questions/questions.component';
import { OverallreportComponent } from '../online-mcq/overallreport/overallreport.component';
import { QuizlistComponent } from '../online-mcq/quizlist/quizlist.component';
import { DailyquizreportComponent } from '../online-mcq/dailyquizreport/dailyquizreport.component';
import { InstructionComponent } from '../online-mcq/instruction/instruction.component';
import { QuickreportComponent } from '../online-mcq/quickreport/quickreport.component';
import { DailyquizComponent } from '../online-mcq/dailyquiz/dailyquiz.component';

export const onlineMcqRoutes: Routes = [
  {
    path: 'online',  
    children: [
      {
        path: 'instruction/:id',
        component: InstructionComponent,
        data: {
          title: 'Made Easy',
          urls: '/online-mcq/instruction'
        }
      },
      {
        path: 'questions/:id',
        component: QuestionsComponent,
        data: {
          title: 'Made Easy',
          urls: '/online-mcq/questions'
        }
      },
      {
        path: 'quickreport/:id',
        component: QuickreportComponent,
        data: {
          title: 'Made Easy',
          urls: '/online-mcq/quickreport'
        }
      },
  ]
  }
];


//SET BELOW ROUTING CODE INSIDE APP-ROUTING.MODULE.TS TO RUN THIS INDEPENTENTLY
/**  
{
  path: 'onlineMCQ',
  component: OnlinemcqComponent,
  children: [
      {
          path: '',
          loadChildren: './online-mcq/online-mcq.module#OnlineMcqModule',
          canActivate:[AuthGuard]
      },
  ]
},
{
  path: 'quiz',
  component: ProfileComponent,
  children: [
      {
          path: '',
          loadChildren: './online-mcq/online-mcq.module#OnlineMcqModule',
          canActivate:[AuthGuard]
      },
  ]
},
 */


// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/online-mcq/online-mcq.routing.ts